/* Copyright (c) 2018 Environmental Systems Research Institute, Inc.
 * Apache-2.0 */
export {};
//# sourceMappingURL=authenticated-request-options.js.map